// Mock data for Yachangu app

export const MALAWI_LOCATIONS = [
  { id: 1, name: 'Lilongwe City Centre', lat: -13.9626, lng: 33.7741 },
  { id: 2, name: 'Kamuzu International Airport', lat: -13.7894, lng: 33.7811 },
  { id: 3, name: 'Area 47 Shopping Centre', lat: -13.9889, lng: 33.7878 },
  { id: 4, name: 'Blantyre City Centre', lat: -15.7861, lng: 35.0058 },
  { id: 5, name: 'Mzuzu City Centre', lat: -11.4596, lng: 34.0150 },
  { id: 6, name: 'Crossroads Mall', lat: -13.9965, lng: 33.7885 },
  { id: 7, name: 'Bingu National Stadium', lat: -13.9833, lng: 33.7667 },
  { id: 8, name: 'Lilongwe Golf Club', lat: -13.9983, lng: 33.7492 },
];

export const RIDE_TYPES = [
  {
    id: 'economy',
    name: 'Yachangu Economy',
    icon: 'Car',
    capacity: '4 seats',
    priceMultiplier: 1,
    description: 'Affordable rides for everyday travel',
    color: '#22c55e'
  },
  {
    id: 'premium',
    name: 'Yachangu Premium',
    icon: 'CarFront',
    capacity: '4 seats',
    priceMultiplier: 1.5,
    description: 'Comfortable rides in premium vehicles',
    color: '#15803d'
  },
  {
    id: 'motorcycle',
    name: 'Yachangu Bike',
    icon: 'Bike',
    capacity: '1 seat',
    priceMultiplier: 0.7,
    description: 'Quick and nimble motorcycle rides',
    color: '#16a34a'
  },
];

export const PAYMENT_METHODS = [
  {
    id: 'airtel',
    name: 'Airtel Money',
    logo: '📱',
    type: 'mobile_money',
    color: '#FF0000'
  },
  {
    id: 'tnm',
    name: 'TNM Mpamba',
    logo: '💳',
    type: 'mobile_money',
    color: '#0066CC'
  },
  {
    id: 'cash',
    name: 'Cash',
    logo: '💵',
    type: 'cash',
    color: '#16a34a'
  },
];

export const MOCK_DRIVERS = [
  {
    id: 'drv1',
    name: 'Chifundo Banda',
    phone: '+265 991 234 567',
    rating: 4.8,
    totalRides: 342,
    vehicle: { 
      model: 'Toyota Corolla', 
      make: 'Toyota',
      plate: 'MW-LL-4521', 
      color: 'Silver',
      year: 2019,
      images: {
        front: 'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=400',
        side: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400',
        back: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=400'
      }
    },
    photo: 'https://i.pravatar.cc/150?img=12',
    currentLocation: { lat: -13.9700, lng: 33.7750 },
    status: 'online',
    rideType: 'economy'
  },
  {
    id: 'drv2',
    name: 'Thandiwe Phiri',
    phone: '+265 999 876 543',
    rating: 4.9,
    totalRides: 589,
    vehicle: { 
      model: 'Mercedes C-Class', 
      make: 'Mercedes-Benz',
      plate: 'MW-BT-8932', 
      color: 'Black',
      year: 2021,
      images: {
        front: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=400',
        side: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=400',
        back: 'https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=400'
      }
    },
    photo: 'https://i.pravatar.cc/150?img=27',
    currentLocation: { lat: -13.9650, lng: 33.7800 },
    status: 'online',
    rideType: 'premium'
  },
  {
    id: 'drv3',
    name: 'James Mwale',
    phone: '+265 888 456 789',
    rating: 4.7,
    totalRides: 234,
    vehicle: { 
      model: 'Honda CB125', 
      make: 'Honda',
      plate: 'MW-MZ-1234', 
      color: 'Red',
      year: 2020,
      images: {
        front: 'https://images.unsplash.com/photo-1558981852-426c6c22a060?w=400',
        side: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=400',
        back: 'https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=400'
      }
    },
    photo: 'https://i.pravatar.cc/150?img=33',
    currentLocation: { lat: -13.9620, lng: 33.7720 },
    status: 'online',
    rideType: 'motorcycle'
  },
];

export const MOCK_RIDE_HISTORY = [
  {
    id: 'ride001',
    date: '2025-07-15',
    time: '14:30',
    from: 'Area 47 Shopping Centre',
    to: 'Lilongwe City Centre',
    driver: {
      id: 'drv1',
      name: 'Chifundo Banda',
      phone: '+265 991 234 567',
      photo: 'https://i.pravatar.cc/150?img=12',
      rating: 4.8,
      vehicle: {
        model: 'Toyota Corolla',
        make: 'Toyota',
        plate: 'MW-LL-4521',
        color: 'Silver'
      }
    },
    amount: 3500,
    currency: 'MWK',
    rideType: 'economy',
    status: 'completed',
    rating: 5
  },
  {
    id: 'ride002',
    date: '2025-07-14',
    time: '09:15',
    from: 'Kamuzu International Airport',
    to: 'Crossroads Mall',
    driver: {
      id: 'drv2',
      name: 'Thandiwe Phiri',
      phone: '+265 999 876 543',
      photo: 'https://i.pravatar.cc/150?img=27',
      rating: 4.9,
      vehicle: {
        model: 'Mercedes C-Class',
        make: 'Mercedes-Benz',
        plate: 'MW-BT-8932',
        color: 'Black'
      }
    },
    amount: 8500,
    currency: 'MWK',
    rideType: 'premium',
    status: 'completed',
    rating: 5
  },
  {
    id: 'ride003',
    date: '2025-07-13',
    time: '18:45',
    from: 'Lilongwe Golf Club',
    to: 'Bingu National Stadium',
    driver: {
      id: 'drv3',
      name: 'James Mwale',
      phone: '+265 888 456 789',
      photo: 'https://i.pravatar.cc/150?img=33',
      rating: 4.7,
      vehicle: {
        model: 'Honda CB125',
        make: 'Honda',
        plate: 'MW-MZ-1234',
        color: 'Red'
      }
    },
    amount: 1800,
    currency: 'MWK',
    rideType: 'motorcycle',
    status: 'completed',
    rating: 4
  },
];

export const MOCK_AVAILABLE_RIDES = [
  {
    id: 'req001',
    passenger: 'Grace Kamanga',
    phone: '+265 991 567 890',
    photo: 'https://i.pravatar.cc/150?img=5',
    pickup: { name: 'Area 47 Shopping Centre', lat: -13.9889, lng: 33.7878 },
    dropoff: { name: 'Lilongwe City Centre', lat: -13.9626, lng: 33.7741 },
    distance: 5.2,
    price: 3500,
    rideType: 'economy',
    requestTime: new Date(Date.now() - 2 * 60000).toISOString(),
  },
  {
    id: 'req002',
    passenger: 'Peter Mvula',
    phone: '+265 888 234 567',
    photo: 'https://i.pravatar.cc/150?img=8',
    pickup: { name: 'Crossroads Mall', lat: -13.9965, lng: 33.7885 },
    dropoff: { name: 'Kamuzu International Airport', lat: -13.7894, lng: 33.7811 },
    distance: 18.5,
    price: 12000,
    rideType: 'premium',
    requestTime: new Date(Date.now() - 5 * 60000).toISOString(),
  },
];

// Utility functions
export const calculatePrice = (distance, rideType) => {
  const baseRate = 500; // MWK
  const perKmRate = 600; // MWK
  const multiplier = RIDE_TYPES.find(rt => rt.id === rideType)?.priceMultiplier || 1;
  return Math.round((baseRate + (distance * perKmRate)) * multiplier);
};

export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  // Haversine formula
  const R = 6371; // Radius of the earth in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return Math.round(distance * 10) / 10;
};

export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) {
    return 'MWK 0';
  }
  return `MWK ${amount.toLocaleString()}`;
};

export const getETA = (distance) => {
  const avgSpeed = 40; // km/h
  const hours = distance / avgSpeed;
  const minutes = Math.round(hours * 60);
  return minutes;
};

// Generate random 5-digit confirmation code
export const generateConfirmationCode = () => {
  return Math.floor(10000 + Math.random() * 90000).toString();
};